
function Sights() {

    return (
        <div>
            <main>
                <section>
                    <div className="banner">
                        <img className='header-image' src="/assets/city-img/sights_banner.JPG" alt="Schiefes Haus" />
                    </div>
                </section>
                <div className="content">
                    <article>
                        <div className="text">
                            <h1>Wismars Sehenswürdigkeiten</h1>
                            <p>Neben atemberaubenden Kirchenbauten gibt es in Wismar noch viel mehr mittelalterliche 
                                Bauwerke und stadtgeschichtliche Orte zu bestaunen. Es lohnt sich, die vielen Straßen 
                                und kleinen Nebenstraßen zu durchwandern, die jede für sich einige Entdeckungen bereithalten.
                                Ohne bestimmtes Ziel lässt sich die Stadt mit ihren Bauwerken, deren Entstehung sich durch 
                                mehrere Jahrhunderte zieht, fast am besten erkunden. Neugierig geworden? Dann findest du hier 
                                bereits einen kleinen Vorgeschmack auf deine nächste Erkundungstour.
                            </p>
                        </div>
                        <div className="text">
                            <h2>Wasserkunst</h2>
                            <p>Die Wasserkunst ist eines der bekanntesten Wahrzeichen Wismars und steht auf dem Marktplatz, 
                                dem größten seiner Art in Norddeutschland. Der reich verzierte Brunnen aus dem 16. Jahrhundert 
                                wurde einst zur Wasserversorgung genutzt und ist heute ein beliebter Treffpunkt sowie Fotomotiv.
                                <br></br>Einfach den Wasserhahn aufdrehen war bis zum Ende des 19. Jhd. in Wismar nicht möglich, 
                                Wasser musste aus Brunnen geholt werden. Dafür gab es mehrere Anlaufstellen, von denen die 
                                Wasserkunst jedoch vermutlich die schönste war. Hin und wieder lässt sich die Wasserkunst im Rahmen 
                                von Führungen von innen besichtigen. 
                            </p>
                        </div>
                        <div className="text">
                            <h2>Gewölbe</h2>
                            <p>Beim "Gewölbe" handelt es sich eigentlich um ein historisches Fachwerkhaus, das direkt über dem 
                                Grubenflüsschen, das Wismar durchzieht, im 17. Jhd. erbaut wurde und ursprünglich Teil der 
                                Stadtbefestigung war. In einigen Teilen bereits der Schwerkraft unterliegend, ist das Gebäude 
                                allerdings ein beliebtes Fotomotiv und fast so typisch für Wismar wie die Wasserkunst.
                            </p>
                        </div>
                        <div className="text">
                            <h2>Frische Grube und Mühlengrube</h2>
                            <p>Diese beiden historischen Wasserläufe durchziehen Wismar und zeugen von der einstigen städtischen 
                                Wasserversorgung. Sie sind heute malerische Spazierwege, die von alten Fachwerkhäusern und Gärten 
                                gesäumt werden. Am Ende der Mühlengrube befindet sich die Stadtmühle, heute eine Industriedenkmal.
                            </p>
                        </div>
                        <div className="text">
                            <h2>Ältestes Wohngebäude</h2>
                            <p>Das älteste Wohnhaus Wismars stammt aus dem Jahre 1430 und beeindruckt durch seine gut 
                                erhaltene Backsteinarchitektur. Mit nur 4,80m Breite gehört es zu einem der eher besonderen 
                                Bauwerke. Es befindet sich in der Dankwartstraße 8 und zeugt von der Lebensweise der damaligen 
                                Zeit.
                            </p>
                        </div>
                        <div className="text">
                            <h2>Schabbellhaus</h2>
                            <p>Das Schabbellhaus ist das Stadtgeschichtliche Museum von Wismar. Es bietet spannende Ausstellungen 
                                über die Geschichte der Hansestadt und beeindruckt zugleich mit seiner prachtvollen Fassade aus der 
                                Renaissancezeit. Es wurde im 16. Jhd. für den späteren Bürgermeister Hinrich Schabbell errichtet.
                            </p>
                        </div>
                        <div className="text">
                            <h2>Fürstenhof</h2>
                            <p>Der Fürstenhof war einst die Residenz der mecklenburgischen Herzöge und zählt zu den bedeutendsten 
                                Renaissancebauten Norddeutschlands. Heute beherbergt er Teile des Amtsgerichts und ist ein 
                                architektonisches Highlight.
                            </p>
                        </div>
                        <div className="text">
                            <h2>Lindenpark</h2>
                            <p>Der Lindenpark ist eine bereits 1815 erbaute, grüne Oase in Wismar, ideal für entspannte Spaziergänge 
                                oder ein Picknick. Der Park ist besonders im Frühjahr und Sommer sehenswert, wenn die Linden in 
                                voller Blüte stehen. Auch hier schlängelt sich der Mühlenbach durch, am nordwestlichen Ende befindet 
                                sich der Alte Wasserturm, ein alter Wehrturm der ehemaligen schwedischen Zitadelle, auf deren Gebiet 
                                der denkmalgeschützte Park entstand.
                            </p>
                        </div>
                        <div className="text">
                            <h2>Karstadt</h2>
                            <p>1881 eröffnete Rudolph Karstadt in Wismar sein erstes Geschäft, 1907 wurde das heutige Karstadt-Gebäude 
                                errichtet. Es ist das Stammhaus der Karstadt AG und war der Go-To-Place der Warenhäuser des 20. Jhd. 
                                Auch in Zeiten von Amazon & Co. lassen sich hier heute noch ganz klassisch wie im vorigen Jahrhundert 
                                Waren erwerben. Im Kontor, dem Rudolph-Karstadt-Museum, lässt sich die Entstehungsgeschichte und das 
                                Wirken des einstigen Kaufmanns nachverfolgen.
                            </p>
                        </div>
                        <div className="text">
                            <h2>Ehemalige Feuerwache</h2>
                            <p>Die ehemalige Feuerwache ist eines der eindrucksvollsten Gebäude des letzten Jahrhunderts. Es wurde 
                                in den 1920ern erbaut und gehört mit seinem expressionistischen Architekturstil eher zu den späten 
                                Bauwerken der Hansestadt.
                            </p>
                        </div>
                    </article>
                </div>
            </main>
        </div>
    )
}

export default Sights;